import { render, staticRenderFns } from "./ReleaseCommission.vue?vue&type=template&id=6850de30&"
import script from "./ReleaseCommission.vue?vue&type=script&lang=js&"
export * from "./ReleaseCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports